import React, { Component } from 'react'
import moment from 'moment'
import {calculateAge} from "../../../helpers/common";
import {useSelector} from "react-redux";

const ClientInfoView = ({ clientInfo, activeTab }) => {
  const { accessFeatures } = useSelector(({ user }) => user);
  const isExtendedForm = !!activeTab

  if (!clientInfo) {
    return null;
  }
  let dateOfBirth = moment(clientInfo.dateOfBirth).format("DD.MM.yyyy")
    return (
      <div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Фамилия</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{clientInfo.lastName}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Собственное имя</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.firstName}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Отчество (при наличии)</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.middleName}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Пол</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.gender}</p>
                </div>
              </div>
            </div>
          </div>
          {
              accessFeatures['client.age'] &&
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="#">Возраст</label>
                  <div className="form-element-data">
                    <div className="form-element-data-text">
                      {clientInfo.dateOfBirth && <span>{calculateAge(clientInfo.dateOfBirth)}</span>}
                    </div>
                  </div>
                </div>
              </div>
          }

        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Место рождения</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.placeOfBirth}</p>
                </div>
              </div>
            </div>
          </div>
          {clientInfo.discountCard &&
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="#">Номер дисконтной карты</label>
                <div className="form-element-data date">
                  <div className="form-element-data-text">
                    <p>{clientInfo.discountCard}</p>
                  </div>
                </div>
              </div>
            </div>
          }
          {clientInfo.payerAccountNumber && isExtendedForm && 
          <div className="form-row-item">
            <div className="form-element">
                <label className="form-element-label" htmlFor="">УНП</label>
                <div className="form-element-data textarea">
                    <div className="form-element-data-text">
                        <p>{clientInfo.payerAccountNumber}</p>
                    </div>
                </div>
            </div>
          </div>}
        </div>

        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Дата рождения</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{dateOfBirth}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Идентификационный номер</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.personal}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Гражданство</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{clientInfo.citizenship}, {clientInfo.residency ? 'резидент РБ' : 'нерезидент'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ClientInfoView
